
import * as d3 from 'd3'

export default {
  data: () => ({
    selectedItems: null,
    getItems: null,
    pdfDrawing: false,
  }),

  methods: {
    set_selectedItems() {
      this.selectedItems = { 
        ...this.selectedItems,
        current: JSON.parse(JSON.stringify(this.current))
      }
    },

    draw_PDF() {
      d3.select(`#UNIT_OVERALL`).transition().duration(300).attr('opacity', .8) 
      d3.select(`#UNIT_TXT_OVERALL`).transition().duration(300).attr('font-weight', 400).attr('fill', '#333')
      d3.select(`#UNIT_IN_OVERALL`).transition().duration(300).attr('opacity', 0)
      d3.select(`#UNIT_OUT_OVERALL`).transition().duration(300).attr('stroke', '#bcbcbc')

      d3.select(`#UNIT_${this.current.handover}`).transition().duration(150).attr('opacity', 1) 
      d3.select(`#UNIT_TXT_${this.current.handover}`).transition().duration(150).attr('font-weight', 450).attr('fill', '#000')
      d3.select(`#UNIT_IN_${this.current.handover}`).transition().duration(150).attr('opacity', 1)
      d3.select(`#UNIT_OUT_${this.current.handover}`).transition().duration(150).attr('stroke', '#44A9DF')

      if (this.current.sys) {
        if(this.canvasOptions) this.canvasOptions.remove()
        if(this.canvasSystems) this.canvasSystems.remove()

        let data = this.setData.find(f => f.SYS == this.current.sys)

        d3.select(`#TITLE`).text(`${data.DESC} (${data.SYS})`)

        this.canvasBoundary = this.canvasForm
        .append('g')
        .attr('transform', `translate(0,0)`)
        .style('font-family', 'roboto').attr('cursor', 'default')

        let overall = this.canvasBoundary
        .append('g')
        .attr('transform', `translate(40,410)`)
        .call(this.call_Page, 'OVERALL', data)

        overall
        .append('circle')
        .attr('cx', 0).attr('cy', 0).attr('r', 8).attr('fill', '#B4E3FA').attr('opacity', 0)

        overall
        .append('circle')
        .attr('id', 'BTN-OVERALL')
        .attr('cx', 0).attr('cy', 0).attr('r', 4).attr('fill', '#B4E3FA').attr('opacity', 1)

        let itr = this.canvasBoundary
        .append('g')
        .attr('transform', `translate(60, 410)`)
        .call(this.call_Page, 'ITR', data)

        itr
        .append('circle')
        .attr('cx', 0).attr('cy', 0).attr('r', 8).attr('fill', '#E0E0DF').attr('opacity', 0)

        itr
        .append('circle')
        .attr('id', 'BTN-ITR')
        .attr('cx', 0).attr('cy', 0).attr('r', 4).attr('fill', '#E0E0DF').attr('opacity', 1)

        this.loadSvg(
          this.canvasBoundary, {
          x   : 20,
          y   : 420,
          url : this.Boundary + `Form_Overall.svg`
        }).then(() => {
          d3.select('#FORM-OVERALL').attr('opacity', this.current.tab == 'OVERALL' ? 1 : 0)
          .attr('visibility', this.current.tab == 'OVERALL' ? 'display' : 'hidden')
          d3.selectAll('text').style('font-family', 'roboto')
          this.dashboard.filter(f=> f.type =='PRO').forEach(d=> {
            let matrix = this.gmx_matrix2(`#${d.id}`)
            d3.select(`#${d.id}`).attr('transform', null).attr('x', matrix.x).attr('y', matrix.y)
          })
          this.innerSvg_Overall(data)
        })

        this.loadSvg(
          this.canvasBoundary, {
          x   : 20,
          y   : 420,
          url : this.Boundary + `Form_ITRs.svg`
        }).then(() => {
          d3.select('#FORM-ITR').attr('opacity', this.current.tab == 'ITR' ? 1 : 0)
          .attr('visibility', this.current.tab == 'ITR' ? 'display' : 'hidden')
          d3.selectAll('text').style('font-family', 'roboto')
          this.itrs.filter(f=> f.type =='PRO').forEach(d=> {
            let matrix = this.gmx_matrix2(`#${d.id}`)
            d3.select(`#${d.id}`).attr('transform', null).attr('x', matrix.x).attr('y', matrix.y)
          })
          this.innerSvg_ITRs(data)
        })

        this.loadSvg(
          this.canvasBoundary, {
          x   : 400,
          y   : 150,
          url : this.Boundary + `svg/${data.SYS}.svg`
        }).then(() => {
          d3.selectAll('text').style('font-family', 'roboto')
        })

        if (this.current.tab == 'OVERALL') {
          d3.select('#BTN-ITR').transition().attr('fill', '#E0E0DF')
          d3.select('#FORM-ITR').transition().attr('opacity', 0)
          d3.select('#FORM-ITR').transition().attr('visibility', 'hidden')

          d3.select('#BTN-OVERALL').transition().attr('fill', '#B4E3FA')
          d3.select('#FORM-OVERALL').attr('visibility', 'display')
          d3.select('#FORM-OVERALL').transition().attr('opacity', 1)

          this.draw_Donuts(this.canvasBoundary, data)
          this.chartRouter(data, 'B')
        } else if (this.current.tab == 'ITR') {
          d3.select('#BTN-OVERALL').transition().attr('fill', '#E0E0DF')
          d3.select('#FORM-OVERALL').transition().attr('opacity', 0)
          d3.select('#FORM-OVERALL').transition().attr('visibility', 'hidden')

          d3.select('#BTN-ITR').transition().attr('fill', '#B4E3FA')
          d3.select('#FORM-ITR').attr('visibility', 'display')
          d3.select('#FORM-ITR').transition().attr('opacity', 1)

          this.chartRouter(data, 'P07')
          this.chartRouter(data, 'I01')
        }
      } else {
        this.filteringData()
        this.canvasSystems.remove()
        this.draw_SystemList()
      }

      let item = this.handover.find(f => f.code == this.current.handover)
      d3.select(`#DIA_HANDOVER2`).text(item.name + `(${item.count})`)

    },
  },

  watch: {
    selectedItems() {
      this.$emit('selectedItems', this.selectedItems)
    },
    current: {
      handler(val) {
        if (!this.pdfDrawing) this.set_selectedItems()
      },
      deep: true
    }
  }
}